enum JackpotType {
	MultiUser = 1,
	Personal = 2,
}

export { JackpotType };
